import { memo, useMemo } from 'react'

import { BaggageWarning } from 'pages/avia/detail-ticket/components/baggage-warning'
import { getBaggageWarning } from 'pages/avia/detail-ticket/libs/getBaggageWarning.tsx'

import { isDifficultAviaRoute } from 'entities/ticket/lib/is-difficult-avia-route'
import findTicketFormStore from 'entities/ticket/models/find-ticket/find-ticket-store'
import { TicketDirectionDetails } from 'entities/ticket/ui/ticket-direction-details'

import { prepareDetailTicketInfo } from 'shared/lib/ticketRender'
import { TicketItem } from 'shared/models/ticket'

import { DetailOffBaggage } from '../../model'
import { SelectTicket, TicketTariff } from '../ticket-tariff'

import styles from './styles.module.scss'

interface Props {
  ticket: TicketItem
  index: number
  passengerCount: number
  shouldLoadTariff?: boolean
  onDetailBaggage: ({ indexes, ticket }: DetailOffBaggage) => void
  onShowTariff: (ticket: TicketItem) => void
  onSelectTicket: (selectTicket: SelectTicket) => void
}

export const TicketSlide = memo(
  ({
    ticket,
    index,
    passengerCount,
    shouldLoadTariff = true,
    onDetailBaggage,
    onShowTariff,
    onSelectTicket,
  }: Props) => {
    const detailTicket = useMemo(() => {
      return prepareDetailTicketInfo(ticket)
    }, [ticket])

    const warningText = useMemo(() => {
      if (!detailTicket?.detailTicketInfo) return null

      return getBaggageWarning(detailTicket.detailTicketInfo)
    }, [detailTicket])

    const isDifficultRoute = isDifficultAviaRoute(
      findTicketFormStore.formFindTicket.directions,
    )

    return (
      <div
        id={`ticket-item-${index}`}
        className={styles.ticketItemWrapper}
      >
        <div
          className={styles.ticketObserverTarget}
          data-ticket-index={index}
        />

        {detailTicket?.detailTicketInfo &&
          detailTicket?.resultsAllListDirections && (
            <TicketDirectionDetails
              detailTicketInfo={detailTicket.detailTicketInfo}
              resultsAllListDirections={detailTicket.resultsAllListDirections}
              isDifficultRoute={isDifficultRoute}
              getDirectionKey={(_, segmentIndex) =>
                `${ticket.tid || index}-${segmentIndex}`
              }
              onDetail={(segmentIndex, flyIndex) =>
                onDetailBaggage({ indexes: [segmentIndex, flyIndex], ticket })
              }
            />
          )}

        {warningText && <BaggageWarning title={warningText} />}

        <TicketTariff
          ticket={ticket}
          shouldLoadTariff={shouldLoadTariff}
          onShowTariffInfo={onShowTariff}
          onSelectTicket={onSelectTicket}
          passengerCount={passengerCount}
        />
      </div>
    )
  },
)

TicketSlide.displayName = 'TicketSlide'
